import React from 'react';
import EloHistoryChart from './EloHistoryChart';
import GameHistoryTable from './GameHistoryTable';
import PlayerRecentSessionsList from './PlayerRecentSessionsList';

/**
 * Summary tab content for Player Dashboard
 */
const PlayerSummaryTab = ({ 
  filteredRecentGames, 
  filteredEloHistory, 
  filteredGames, 
  baseClubGames,
  isLoading, 
  isLoadingGames,
  currentPlayerId,
  onViewSession,
  clubId = null,
}) => {
  return (
    <div className="space-y-8">
      {/* ELO History Chart */}
      <div className="overflow-hidden rounded-2xl border border-border-light bg-surface shadow-brand-sm">
        <div className="border-b border-border-light px-5 py-4 sm:px-6">
          <h2 className="text-lg font-bold text-text-primary sm:text-xl">
            ELO Rating History
          </h2>
          <p className="mt-0.5 text-sm text-text-secondary">
            Your rating progression across competitive games
          </p>
        </div>

        <div className="p-4 sm:p-6">
          {isLoading ? (
            <div className="flex h-80 items-center justify-center">
              <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
            </div>
          ) : filteredEloHistory.length === 0 ? (
            <div className="flex h-80 items-center justify-center rounded-2xl bg-surface-subtle">
              <p className="text-sm text-text-muted">No ELO history available for the selected filters.</p>
            </div>
          ) : (
            <div className="h-80 sm:h-96">
              <EloHistoryChart
                eloHistory={filteredEloHistory}
                pairType="all"
                selectedPlayer={null}
              />
            </div>
          )}
        </div>
      </div>

      {/* Sessions list - games at the selected club (latest first) */}
      <PlayerRecentSessionsList
        games={baseClubGames || filteredGames}
        currentPlayerId={currentPlayerId}
        clubId={clubId}
      />
      
      {/* Game History Table */}
      {isLoadingGames ? (
        <div className="flex justify-center items-center h-24">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
        </div>
      ) : (
        <GameHistoryTable
          games={filteredGames}
          pageSize={10}
          clubId={clubId}
          latestSessionOnlyByDefault
        />
      )}
    </div>
  );
};

export default PlayerSummaryTab;
